/**
 * Configures the Redux store with the rootReducer and default middleware.
 */
import rootReducer from '@app/store/slices';
import { configureStore } from '@reduxjs/toolkit';

export const store = configureStore({
	reducer: rootReducer,
	middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});

/**
 * The root state type of the Redux store.
 */
export type RootState = ReturnType<typeof store.getState>;

/**
 * The dispatch type of the Redux store.
 */
export type AppDispatch = typeof store.dispatch;

/**
 * Action creator for resetting the entire Redux store to its initial state.
 *
 * Dispatching this action will cause the rootReducer to reset all slices.
 * Useful for logout or when a full state reset is required.
 *
 * @returns An action with type 'RESET_STORE'
 */
export const resetStore = () => ({ type: 'RESET_STORE' });
